/* ============
 * Actions for the account module
 * ============
 *
 * The actions that are available on the
 * account module.
 */

import Vue from 'vue'
import decode from 'jwt-decode'

import AccountTransformer from '@/app/transformers/AccountTransformer'
import MerchantTransformer from '@/app/transformers/MerchantTransformer'
import * as storageKeys from '../auth/storage-keys'
import * as types from './mutation-types'

export async function find ({commit, state}) {
  const userFromToken = decode(Vue.$storage.get(storageKeys.ID_TOKEN))

  const userFromContentful = await Vue.$api.userEmailGet({email: userFromToken['name']})
  commit(types.FIND, AccountTransformer.fetch(Object.assign(userFromToken, userFromContentful.data)))

  // get all merchants data
  const merchantData = await Vue.$http.all(userFromContentful.data['merchants'].map(merchant => {
    return Vue.$api.merchantIdGet({id: merchant['merchant_id']})
  }))

  let merchants = []
  merchantData.map(res => res.data)
    .forEach(res => {
      merchants.push(MerchantTransformer.fetch(res.Items[0]))
    })
  commit(types.MERCHANTS, merchants)

  if (!state.selectedMerchant) {
    commit(types.SELECTED_MERCHANT, merchants[0])
  }
}

export const reset = ({commit}) => {
  commit(types.RESET)
}

export default {
  find,
  reset
}



// WEBPACK FOOTER //
// ./src/app/store/modules/account/actions.js